import React from 'react'
import { useTranslation } from 'react-i18next'

import { TableCell, TableRow } from '@mui/material'

import AcquiringSettlementsModal from 'components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsViewModal/AcquiringSettlementsModal'
import { useStyles } from 'components/core/Acquiring/AcquiringSettlements/components/styles'
import { ToggleView } from 'components/core/Acquiring/styles'
import { dateAndTimeToLocaleString } from 'utils/helperNumbersFormating'

interface RowProps {
    record: ParsedRecord
}

const AcquiringSettlementsTableRow: React.FC<RowProps> = ({ record }) => {
    const { t } = useTranslation(['override', 'translations', 'keys'])
    const classes = useStyles()

    return (
        <TableRow className={classes.rowRoot} hover>
            <TableCell align="left" component="th" scope="row" padding="normal">
                {dateAndTimeToLocaleString(record?.periodFrom)}
            </TableCell>
            <TableCell align="left" component="th" scope="row" padding="normal">
                {record?.totalCharges}
            </TableCell>
            <TableCell align="left" component="th" scope="row" padding="normal">
                {record?.totalRefunds}
            </TableCell>
            <TableCell align="left" component="th" scope="row" padding="normal">
                {record?.totalChargeBacks}
            </TableCell>
            <TableCell align="right" component="th" scope="row" padding="normal">
                {record?.finalAmount}
            </TableCell>
            <TableCell align="right" component="th" scope="row" padding="normal">
                <AcquiringSettlementsModal record={record}>
                    <ToggleView> {t('Acquiring.View')} </ToggleView>
                </AcquiringSettlementsModal>
            </TableCell>
        </TableRow>
    )
}

export default AcquiringSettlementsTableRow
